import { StyleSheet } from 'react-native';
import { darkTheme } from '../../../src/theme/themes';
import { CUSTOMIZER_SURFACE } from './characterCustomizer.constants';

export const collectionBadgeStyles = StyleSheet.create({
  pill: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 9,
    alignSelf: 'flex-end',
    paddingLeft: 6,
    paddingRight: 14,
    paddingVertical: 5,
    borderRadius: 9999,
    backgroundColor: CUSTOMIZER_SURFACE.collectionBg,
    borderWidth: 1,
    borderColor: CUSTOMIZER_SURFACE.collectionBorder,
  },
  label: {
    fontSize: 9,
    fontWeight: '800',
    color: darkTheme.gray[500],
    letterSpacing: 0.8,
  },
  count: {
    fontSize: 14,
    fontWeight: '800',
    color: darkTheme.white,
    fontVariant: ['tabular-nums'],
  },
  countTotal: {
    color: darkTheme.gray[400],
  },
});
